import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { RentalShop } from './pages/RentalShop';
import { Inspiration } from './pages/Inspiration';
import { Service } from './pages/Service';
import { AboutUs } from './pages/AboutUs';
import { Contact } from './pages/Contact';
import { ShopProducts } from './pages/ShopProducts';
import { EventDetail } from './pages/EventDetail';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
        <Route path="/rental-shop" element={<RentalShop data-id="element-6" />} data-id="element-5" />
        <Route path="/inspiration" element={<Inspiration data-id="element-8" />} data-id="element-7" />
        <Route path="/service" element={<Service data-id="element-10" />} data-id="element-9" />
        <Route path="/about-us" element={<AboutUs data-id="element-12" />} data-id="element-11" />
        <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
        <Route path="/shop-products" element={<ShopProducts data-id="element-16" />} data-id="element-15" />
        <Route path="/events/:eventSlug" element={<EventDetail data-id="element-18" />} data-id="element-17" />
      </Routes>
    </BrowserRouter>;
}